import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { COLOR } from '@src/styles/color';

export const StyledAutoRenewSectionNew = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 16px;
  .content-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${COLOR.darkGray};
    .label {
      font-weight: 400;
      font-size: 14px;
    }
    .content {
      font-size: 14px;
      font-weight: 700;
      display: flex;
      align-items: center;
    }
  }
  .header-container-auto-renewal {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 24px;
    cursor: pointer;
  }

  .header-label {
    font-weight: 400;
    color: ${COLOR.darkGray};
    letter-spacing: -0.4px;
  }

  .header-label.mobile {
    font-size: 12px;
    line-height: 16px;
  }

  .header-label:not(.mobile) {
    font-size: 14px;
    line-height: 20px;
  }

  .header-right {
    display: flex;
    gap: 4px;
    align-items: center;
  }

  .status-badge {
    padding: 4px 12px;
    border-radius: 480px;
  }

  .status-badge.active {
    background-color: ${COLOR.greenV2[8]};
  }

  .status-badge:not(.active) {
    background-color: ${COLOR.label[8]};
  }

  .status-text {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.4px;
  }

  .status-text.active {
    color: ${COLOR.greenV2.default};
  }

  .status-text:not(.active) {
    color: ${COLOR.label[64]};
  }

  .expand-icon {
    width: 20px;
    height: 20px;
    color: ${COLOR.indigo[100]};
  }

  .detail-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px;
    border-radius: 8px;
    background-color: ${COLOR.charcoal};
  }

  .renewal-plan-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .renewal-plan-label {
    font-weight: 400;
    color: ${COLOR.darkGray};
    letter-spacing: -0.4px;
  }

  .renewal-plan-label.mobile {
    font-size: 12px;
    line-height: 16px;
  }

  .renewal-plan-label:not(.mobile) {
    font-size: 14px;
    line-height: 20px;
  }

  .renewal-plan-value {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: ${COLOR.darkGray};
    letter-spacing: -0.4px;
  }

  .button-subscription {
    display: flex;
    height: 32px;
    padding: 8px 12px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid rgba(30, 22, 78, 0.32);
    background: white;
    text-transform: none;
  }

  .cancel-auto-renew-buttons-container {
    display: flex;
    gap: 8px;
    width: 100%;
  }

  .agree {
    flex: 1;
  }

  .disagree {
    flex: 1;
  }
`;

export const StyledHeaderLabel = styled(Typography)(({ isMobile }) => ({
  fontSize: isMobile ? '12px' : '14px',
  fontWeight: 400,
  lineHeight: isMobile ? '16px' : '20px',
  color: COLOR.darkGray,
  letterSpacing: '-0.4px',
}));

export const StyledRenewalPlanLabel = styled(Typography)(({ isMobile }) => ({
  fontSize: isMobile ? '12px' : '14px',
  fontWeight: 400,
  lineHeight: isMobile ? '16px' : '20px',
  color: COLOR.darkGray,
  letterSpacing: '-0.4px',
}));

export const StyledPackageCardNew = styled(Box)(({ isMobile }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: isMobile ? '16px' : '24px',
  borderRadius: '12px',
  backgroundColor: COLOR.white,
  border: `1px solid ${COLOR.label[16]}`,
  maxWidth: isMobile ? '100%' : '552px',
  flex: 1,
  boxSizing: 'border-box',
  '.header-container-package': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottom: 'none',
    flexDirection: 'column',
    gap: '4px',
  },

  '.header-left': {
    display: 'flex',
    gap: '2px',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },

  '.package-title': {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '24px',
    color: COLOR.darkGray,
    letterSpacing: '-0.4px',
  },

  '.expiry-container': {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },

  '.expiry-label': {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: COLOR.label[64],
    letterSpacing: '-0.4px',
  },

  '.expiry-date': {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '-0.4px',
  },

  '.expiry-date.expired': {
    color: COLOR.functionalRed.default,
  },

  '.expiry-date:not(.expired)': {
    color: COLOR.label[64],
  },

  '.expired-badge': {
    padding: '4px 12px',
    borderRadius: '480px',
    backgroundColor: COLOR.functionalRed[8],
  },

  '.expired-text': {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    color: COLOR.functionalRed.default,
    letterSpacing: '-0.4px',
  },

  '.divider': {
    borderColor: COLOR.label[16],
  },

  '.content-container': {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  '.character-section': {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },

  '.next-reset-text': {
    fontWeight: 400,
    lineHeight: '16px',
    color: COLOR.label[64],
    letterSpacing: '-0.4px',
  },

  '.next-reset-text.mobile': {
    fontSize: '10px',
  },

  '.next-reset-text:not(.mobile)': {
    fontSize: '12px',
  },

  '.stt-section': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },

  '.stt-label': {
    fontWeight: 400,
    color: '#000000',
    letterSpacing: '-0.4px',
  },

  '.stt-label.mobile': {
    fontSize: '12px',
    lineHeight: '16px',
  },

  '.stt-label:not(.mobile)': {
    fontSize: '14px',
    lineHeight: '20px',
  },
}));

export const StyledExpiryDate = styled(Typography)(({ isExpired }) => ({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  color: isExpired ? COLOR.functionalRed.default : COLOR.label[64],
  letterSpacing: '-0.4px',
}));

export const StyledNextResetText = styled(Typography)(({ isMobile }) => ({
  fontSize: isMobile ? '10px' : '12px',
  fontWeight: 400,
  lineHeight: '16px',
  color: COLOR.label[64],
  letterSpacing: '-0.4px',
}));

export const StyledSTTLabel = styled(Typography)(({ isMobile }) => ({
  fontSize: isMobile ? '12px' : '14px',
  fontWeight: 400,
  lineHeight: isMobile ? '16px' : '20px',
  color: '#000000',
  letterSpacing: '-0.4px',
}));

export const StyledPackageInfoAPIRow = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',

  '.row-content': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },

  '.label': {
    fontSize: '12px',
    fontWeight: 400,
    color: COLOR.label[64],
    letterSpacing: '-0.4px',
  },

  '.value-container': {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },

  '.value': {
    fontSize: '12px',
    lineHeight: '20px',
    color: COLOR.label[64],
    letterSpacing: '-0.4px',
  },

  '.tooltip-icon': {
    width: '16px',
    height: '16px',
    color: COLOR.indigo[100],
    cursor: 'pointer',
  },

  '.sub-label, .sub-value': {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    color: COLOR.label[64],
    letterSpacing: '-0.4px',
  },
});

export const StyledPackageInfoRow = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',

  '.row-content': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },

  '.label': {
    fontWeight: 400,
    color: '#000000',
    letterSpacing: '-0.4px',
  },

  '.value-container': {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },

  '.value': {
    letterSpacing: '-0.4px',
  },

  '.tooltip-icon': {
    width: '16px',
    height: '16px',
    color: COLOR.indigo[100],
    cursor: 'pointer',
  },

  '.sub-label, .sub-value': {
    fontWeight: 400,
    lineHeight: '16px',
    color: COLOR.label[64],
    letterSpacing: '-0.4px',
  },
});

export const StyledBadgeContainer = styled(Box)(({ bgColor }) => ({
  display: 'flex',
  gap: '4px',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '4px 8px',
  borderRadius: '8px',
  backgroundColor: bgColor,
}));

export const StyledDot = styled(Box)(({ dotColor }) => ({
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  backgroundColor: dotColor,
}));

export const StyledBadgeText = styled(Typography)(({ isExpired }) => ({
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
  color: isExpired ? COLOR.functionalRed.default : COLOR.darkGray,
  letterSpacing: '-0.4px',
}));

export const StyledV2WarningBox = styled(Box)`
  display: flex;
  gap: 8px;
  padding: 12px;
  border-radius: 8px;
  background-color: ${COLOR.orangeV2[8]};
  align-items: flex-start;

  .warning-icon {
    width: 20px;
    height: 20px;
    color: ${COLOR.orangeV2[100]};
  }
`;

export const StyledApiPackageConversionNotification = styled(Box)(
  ({ isMobile }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: isMobile ? '12px' : '8px 12px',
    borderRadius: '8px',
    backgroundColor: 'rgba(0, 122, 255, 0.08)',
    width: '100%',
    minHeight: isMobile ? 'auto' : '40px',
    boxSizing: 'border-box',
    justifyContent: 'space-between',
    '.notification-content': {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },

    '.info-icon': {
      width: '20px',
      height: '20px',
      color: '#007AFF',
      flexShrink: 0,
    },

    '.notification-text': {
      flex: 1,
      fontSize: isMobile ? '12px' : '14px',
      fontWeight: 400,
      lineHeight: isMobile ? '16px' : '20px',
      color: COLOR.darkGray,
      letterSpacing: '-0.4px',
    },

    '.view-detail-link': {
      color: '#007AFF',
      textDecoration: 'underline',
      cursor: 'pointer',
      textUnderlinePosition: 'from-font',
      '&:hover': {
        opacity: 0.8,
      },
    },

    '.close-button': {
      padding: '4px',
      flexShrink: 0,
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },

    '.close-icon': {
      width: '20px',
      height: '20px',
      color: COLOR.indigo[100],
    },
  }),
);
